import type { PrintingAction } from 'redux/actions/printing';

import { CLEAR_PRINTING_DATA, SET_PRINTING_DATA } from 'redux/actions/printing';

export type PrintingState = {
  docUrl: string | null;
  docName: string | null;
};

const printingInitialState: PrintingState = {
  docUrl: null,
  docName: null,
};

export default function reducer(
  state: PrintingState = printingInitialState,
  action: PrintingAction,
): PrintingState {
  switch (action.type) {
    case SET_PRINTING_DATA:
      return { ...state, docUrl: action.payload.docUrl, docName: action.payload.docName };
    case CLEAR_PRINTING_DATA:
      return { ...state, docUrl: null, docName: null };
    default:
      return state;
  }
}
